export const projects = [
	{
		header: `Crypto Hub`,
		para: [`I have created this website for my portfolio`, `I have used Reactjs and  Material UI for Designing`, `I have used crypto api for Coin`],

		img: `images/CryptoHubClone.png`,
		pullImg: "img-right",
		altText: `poject 1`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://crypto-tracker-hub.netlify.app/`,
	},
	{
		header: `Moving From`,
		para: [`I have created this website for client`, `I have used Reactjs and  Material UI for Designing`, `I have created custom stepper`],
		img: `images/movingForm.png`,
		pullImg: "img-left",
		altText: `moving form`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://terrymovingform.netlify.app/`,
	},
	{
		header: `Todist Clone`,
		para: [`I have created this website for my portfolio`, `This is todoist website clone`],
		img: `images/todoisClone.png`,
		pullImg: "img-right",
		altText: `Todoist Clone`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://todoist-clone-21616.firebaseapp.com/`,
	},
	{
		header: `Math Lab`,
		para: [`I have created this website for my portfolio`, `This is quiz app`],
		img: `images/mathlab.png`,
		pullImg: "img-left",
		altText: `quiz app`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://digital-math-lab.netlify.app/`,
	},
	{
		header: `Global Money 4 You`,
		para: [`I have created this professional Website for my client`, `I have used Reactjs and  Material UI for Designing`, `For backend  I have used Nodejs, Express, MongoDB, and Heroku`],

		img: `images/project5.png`,
		pullImg: "img-right",
		altText: `poject 1`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://globalmoney4u.net/`,
	},
	{
		header: `Admin Panel Layout`,
		para: [`I have created this Admin Panel Layout for sharpen my skills`, `I have used Angular 10 and Material for Designing`, `It is static page that host on firebase`],

		img: `images/project6.png`,
		pullImg: "img-left",
		altText: `poject 2`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://admin-layout.web.app/`,
	},
	{
		header: `Student Panel Layout`,
		para: [`I have created this Student Admin Panel Layout for sharpen my skills`, `I have used React Js and Material Ui for Designing`, `It is static page that host on firebase`],

		img: `images/project9.png`,
		pullImg: "img-right",
		altText: `poject 2`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://studen-panel.netlify.app/`,
	},
	{
		header: `Site Monitoring App`,
		para: [`This is site monitoring app that keep track of site up and down state`, `This site is made in pure Nodejs and the admin panel is a CLI based.`, `It is fully functional app that is hosted on heroku.`],

		img: `images/project10.png`,
		pullImg: "img-right",
		altText: `poject 2`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://site-monitoring-app.herokuapp.com/`,
	},
	{
		header: `Amazon Ecommerce Shop Clone`,
		para: [`I have created this Ecommerce Store for my portfolio`, `I have used ReactJs and Material-Ui for Designing`, `It is full ecommerce store with cart and check out functionality.`, `I have used firebase for authentication and stripe for checkout functionality`],

		img: `images/project8.png`,
		pullImg: "img-left",
		altText: `poject 8`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://clone-fecac.web.app/`,
	},
	{
		header: `Whats App Web Clone`,
		para: [`This is whatsapp Web clone i have created`, `I have used Reactjs  and Material UI for Designing`, `For authentication and storage I have used Firebase google Auth and real time database`],

		img: `images/project7.png`,
		pullImg: "img-right",
		altText: `poject 3`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://whatsapp-clone-fe45c.web.app/`,
	},
	{
		header: `Social Media Example`,
		para: [`I have created this simple app as an improvement self learning skill in Reactjs And Firebase`, `I have used React Material for Designing`, `For backend and database i have used firebase and mongodb`],

		img: `images/project1.png`,
		pullImg: "img-left",
		altText: `poject 4`,
		btnPara: `See Site`,
		internalLink: false,
		link: `https://socialapp-58772.firebaseapp.com/`,
	},
	{
		header: `Resourt Website`,
		para: [`A react app for hotel booking,`],
		img: `images/project2.png`,
		pullImg: "img-right",
		altText: `project 5`,
		btnPara: `See WebSite`,
		internalLink: false,
		link: `https://resourt-app.firebaseapp.com/`,
	},
	{
		header: `Burger Builder App`,
		para: [`A react app Burger Builder`, `React Redux and Firebase`],
		img: `images/project3.png`,
		pullImg: "img-left",
		altText: `project 6`,
		btnPara: `See WebSite`,
		internalLink: false,
		link: `https://burger-builder-92888.web.app/`,
	},
	{
		header: `Covid-19 Tracker  `,
		para: [`A react app Covid 19 tracker `],
		img: `images/project4.png`,
		pullImg: "img-right",
		altText: `project 7`,
		btnPara: `See WebSite`,
		internalLink: false,
		link: `https://covid-19-tracker-67089.web.app/`,
		//link: `https://covid-19-tracker-d0bb1.web.app/`,
	},
];
